import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import WelcomePage from './WelcomePage';
import MainLayout from './MainLayout';
import { useAuth } from './context/AuthContext';
import './App.css';
import './Auth.css';
import './Tour.css';

/**
 * A protected route component that checks for a token in local storage.
 * If the token exists, it renders the children components.
 * Otherwise, it navigates to the welcome page.
 * For larger applications, this could be moved to its own file (e.g., src/components/ProtectedRoute.js).
 */
const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  if (!token) {
    return <Navigate to="/welcome" />;
  }
  return children;
};

/**
 * The main application component.
 * It sets up the router and handles top-level routes for authentication
 * and the main application layout. All application logic and UI for the
 * authenticated experience has been moved to the MainLayout component.
 */
function App() {
  const { token } = useAuth();

  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <Routes>
        <Route path="/welcome" element={<WelcomePage />} />
        <Route path="/login" element={<WelcomePage showModal="login" />} />
        <Route path="/register" element={<WelcomePage showModal="register" />} />
        <Route path="/" element={
            <ProtectedRoute>
              <MainLayout />
            </ProtectedRoute>
          } 
        />
        {/* Fallback route to redirect users to the correct page based on auth status */}
        <Route path="*" element={<Navigate to={token ? "/" : "/welcome"} />} />
      </Routes>
    </Router>
  );
}

export default App;
